<template>
  <div class="common_wrap bg_grey color_black relative">
    <div v-if="!this.actInfo.bindUser" class="error_state"></div>
    <div v-else-if="!this.actInfo.white" class="error_state">活动已结束</div>
    <div v-else class="main">
      <div class="game_module" v-for="it in gameList" :key="it.gameId">
        <GameModule
          v-bind="it"
          :bannerList="it.bannerList"
          @go="handleGo(it)"
        />
      </div>
    </div>
    <GuidePopup
      ref="guideRef"
      :pic="pic"
      @confirm="handleGuideConfirm"
    />
  </div>
</template>

<script>
import { getGameListApi, getGameInfoApi } from '@/apis/activity.api'
import store from "@/store";
import parseQuery from '@/mixins/parseQuery'
import GuidePopup from '@/components/GuidePopup'
import GameModule from '@/components/GameModule'
import trackingMixin, { EVENT_TYPE_ENUM } from "@/mixins/tracking"; 
import { getGameInfoById } from '@/apis/common.api' 
export default {
  mixins: [parseQuery, trackingMixin],
  components: {
    GuidePopup,
    GameModule,
  },
  data () {
    return {
      pic: '',
      actInfo: {},
      fields: ['activityId'], 
      gameList: [],
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    // 埋点所需的活动信息
    trackActInfo () {
      return {
        activity_id: this.actInfo.id,
        activity_name: this.actInfo.name,
      }
    },
    // 埋点所需的游戏信息
    trackAppInfo () {
      return {
        appkey: this.actInfo.gameId,
        appName: this.actInfo.gameName,
      }
    },
  },
  methods: {
    init () {
      this.getActInfo().then(res => {
        if (this.actInfo.white) {
          this.getMainInfo()
        }
      })
    },
    getActInfo () {
      // "1-未获取角色 2-非白名单 3-白名单"
      let page_type
      return getGameInfoApi({
        wxappid: this.$storeGet('WX_APP_ID'),
        openid: store.getters['user/openid'],
        id: this.params.activityId,
      }).then(res => {
        this.actInfo = res.data
        const { white, bindUser } = res.data
        page_type = white ? 3 : 2
        if (!bindUser) {
          page_type = 1
          this.handleGetGameInfo().then(() => {
            this.$refs.guideRef.triggerVisible(true)
            this.EVENT_TRACKING(
              EVENT_TYPE_ENUM.wechat_game_center_not_bind_user_pop,
              this.trackActInfo,
              this.trackAppInfo
            )
          })
        }
      }).finally(() => {
        this.EVENT_TRACKING(
          EVENT_TYPE_ENUM.wechat_game_center_page,
          {
            ...this.trackActInfo,
            page_type
          },
          this.trackAppInfo
        )
      })
    },
    getMainInfo () {
      getGameListApi({
        wxappid: this.$storeGet('WX_APP_ID'),
        openid: store.getters['user/openid'],
        id: this.actInfo.id,
      }).then(res => {
        this.gameList = res.data || []
      })
    },

    handleGetGameInfo () {
      return getGameInfoById({
        gameId: this.actInfo.gameId,
      }).then(res => {
        const { pic } = res.data
        this.pic = pic
      })
    },

    handleGo (game) {
      const { url, gameId, gameName } = game
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_game_center_one_key_play_button,
        {
          ...this.trackActInfo,
          click_game_id: gameId,
          click_game_name: gameName
        },
        this.trackAppInfo
      )
      setTimeout(() => {
        window.open(url, '_blank')
      }, 150)
    },

    handleGuideConfirm () {
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_game_center_know_button,
        this.trackActInfo,
        this.trackAppInfo
      )
    },
  },
}
</script>

<style lang='scss' scoped>
.main {
  padding: 8px 10px 16px;
}

.game_module + .game_module {
  margin-top: 12px;
}
</style>